import React, { useState } from "react";
import "../styles/AudioPlayer.css"; // Import the CSS file

const AudioPlayer = ({ title, playlist, className = "" }) => {
    const [currentTrackIndex, setCurrentTrackIndex] = useState(0);

    const handleTrackChange = (index) => {
        setCurrentTrackIndex(index);
    };

    if (!playlist || playlist.length === 0) {
        return <div>No audio tracks available.</div>;
    }

    return (
        <div className={`audio-player ${className}`}>
            <h3 className="text-lg font-bold text-red-900 mb-4">{title}</h3>
            <audio
                key={playlist[currentTrackIndex].src}
                controls
                className="w-full"
            >
                <source src={playlist[currentTrackIndex].src} type="audio/mp3" />
                Your browser does not support the audio element.
            </audio>
            <ul className="mt-4 list-decimal list-inside">
                {playlist.map((track, index) => (
                    <li
                        key={index}
                        className={`cursor-pointer py-1 ${
                            index === currentTrackIndex
                                ? "text-blue-600 font-semibold"
                                : "text-gray-700"
                        }`}
                        onClick={() => handleTrackChange(index)}
                    >
                        {track.title}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default AudioPlayer;
